<template>
  <v-menu
    v-model="notificationMenuIsOpen"
    bottom
    left
    offset-y
    open-on-click
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ attrs, on }">
      <v-fade-transition duration="5000">
        <v-btn
          min-width="0"
          text
          v-bind="attrs"
          v-on="on"
          v-show="$route.name == 'whiteboard'"
        >
          <v-badge
            color="red"
            overlap
            bordered
            :value="unseenNotifications !== 0"
          >
            <template
              v-slot:badge
            >
              <span>{{ unseenNotifications }}</span>
            </template>

            <v-icon>mdi-bell</v-icon>
          </v-badge>
        </v-btn>
      </v-fade-transition>
    </template>

    <v-list
      :tile="false"
      nav
      v-if="notifications.length"
    >
      <div style="overflow-y:auto; max-height: 400px" >
        <DarkListItem
          v-for="(n, i) in notifications"
          :key="`notification-${i}`"
        >
          <v-list-item-title
            v-text="n"
          />
        </DarkListItem>
      </div>
    </v-list>
    <v-card
      v-else
      width="200"
      height="100"
    >
      <v-row
        justify="center"
        align="center"
        style="height: 100%; color: grey">
        <v-btn disabled text class="black--text"> No new notifications </v-btn>
      </v-row>
    </v-card>
  </v-menu>
</template>

<script>
import { mapState } from 'vuex'
import DarkListItem from './utils/DarkListItem'

export default {
  name: 'Notifications',

  components: {
    DarkListItem
  },

  created: () => {
    console.log('created')
  },

  data: () => ({
    notificationMenuIsOpen: false,
    unseenNotifications: 0
  }),

  computed: {
    ...mapState({
      notificationLog: state => state.event.notificationLog
    }),

    notifications () {
      var notifs = []
      if (this.notificationLog) {
        notifs = this.notificationLog.map(n => n.payload).reverse()
      }
      return notifs
    }
  },

  watch: {
    notificationLog () {
      if (this.notificationLog.length > 0 && !this.notificationMenuIsOpen) {
        this.unseenNotifications++
      }
    },

    notificationMenuIsOpen () {
      this.unseenNotifications = 0
    }
  }
}
</script>
